import {Component} from '@angular/core';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-tekst-vrijgestelde-winst',
  templateUrl: './tekst-vrijgestelde-winst.component.html',
  styleUrls: ['./tekst-vrijgestelde-winst.component.scss'],
})
export class TekstVrijgesteldeWinstComponent {}
